import React from 'react'
import { Exchange } from '../../component/education/Exchange'

export default function ExchangePage() {
  return (
    <>
      <Exchange />
    </>
  )
}
